import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { CheckoutBillingAddressComponent } from './checkout-billing-address.component';

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutBillingAddress: {
          component: CheckoutBillingAddressComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  declarations: [CheckoutBillingAddressComponent],
  exports: [CheckoutBillingAddressComponent],
})
export class CheckoutBillingAddressModule {}
